import classNames from 'classnames';
import { Button } from '@acb_devel/design-system';
import { AngleLeftIcon } from '@acb_devel/design-system';
import { AngleRightIcon } from '@acb_devel/design-system';
import { Text } from '@acb_devel/design-system';

import styles from './DataTablePaginator.module.scss';

export function DataTablePaginator({
  totalRows,
  perPage,
  page,
  setPage,
  maxPages = 5,
  className,
}: {
  totalRows: number;
  perPage: number;
  page: number;
  setPage: (page: number) => void;
  maxPages?: number;
  className?: string;
}) {
  const totalPages = Math.ceil(totalRows / perPage);

  // Calcular el rango de páginas a mostrar
  const halfMaxPages = Math.floor(maxPages / 2);
  let startPage = Math.max(1, page - halfMaxPages);
  let endPage = Math.min(totalPages, page + halfMaxPages);

  // Ajustar cuando esté cerca del inicio o el final
  if (page <= halfMaxPages) {
    endPage = Math.min(totalPages, maxPages);
  } else if (page + halfMaxPages >= totalPages) {
    startPage = Math.max(1, totalPages - maxPages + 1);
  }

  const pages = Array.from(
    { length: endPage - startPage + 1 },
    (_, index) => startPage + index
  );

  return (
    <div className={classNames(styles.paginator, className)}>
      <div className={classNames(styles.paginator__buttons)}>
        <Button
          onClick={() => setPage(page - 1)}
          disabled={page === 1 || totalRows === 0}
          isOnlyIcon
        >
          <AngleLeftIcon />
        </Button>
        <div>
          {totalRows === 0 && (
            <Button color="secondary" variant="flat" isOnlyIcon disabled>
              1
            </Button>
          )}
          {pages.map((pageNumber) => {
            const isCurrentPage = pageNumber === page;
            return (
              <Button
                key={pageNumber}
                onClick={() => setPage(pageNumber)}
                color="secondary"
                variant="flat"
                disabled={isCurrentPage}
                isOnlyIcon
              >
                {pageNumber}
              </Button>
            );
          })}
        </div>
        <Button
          onClick={() => setPage(page + 1)}
          disabled={page === Math.ceil(totalRows / perPage) || totalRows === 0}
          isOnlyIcon
        >
          <AngleRightIcon />
        </Button>
      </div>
      <div className={styles.paginator__info}>
        <Text variant="body-2">
          <>
            {' '}
            {totalRows === 0 && 'No hay registros'}
            {totalRows > 0 && (
              <>
                Total <b>{totalRows}</b> registros con los filtros seleccionados
              </>
            )}
          </>
        </Text>
      </div>
    </div>
  );
}
